import React, { useState } from 'react';
import api from '../utils/api';
import './AddDepartmentDialog.css';

const AddDepartmentDialog = ({ faculty, isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    nameEn: '',
    faculty: '',
    faculty_ref: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Set faculty data when dialog opens
  React.useEffect(() => {
    if (faculty && isOpen) {
      setFormData({
        name: '',
        nameEn: '',
        faculty: faculty.name,
        faculty_ref: faculty._id
      });
      setError('');
    }
  }, [faculty, isOpen]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/departments', formData);
      
      if (response.data.success) {
        onSave(response.data.data);
        onClose();
        // Reset form
        setFormData({ name: '', nameEn: '', faculty: '', faculty_ref: '' });
      } else {
        setError(response.data.message || 'Failed to create department');
      }
    } catch (err) {
      if (err.response?.status === 400) {
        setError('Missing required fields. Please fill in all fields.');
      } else if (err.response?.status === 500) {
        setError('Server error. Please try again later.');
      } else {
        setError('An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
      // Reset form and error when closing
      setFormData({ name: '', nameEn: '', faculty: '', faculty_ref: '' });
      setError('');
    }
  };

  if (!isOpen || !faculty) return null;

  return (
    <div className="dialog-overlay" onClick={handleClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>Add New Department</h2>
          <p className="faculty-info">Faculty: {faculty.name}</p>
          <button 
            className="close-button" 
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="dialog-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="name">Department Name (Bengali) *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter department name in Bengali"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="nameEn">Department Name (English) *</label>
            <input
              type="text"
              id="nameEn"
              name="nameEn"
              value={formData.nameEn}
              onChange={handleChange}
              required
              placeholder="Enter department name in English"
              disabled={loading}
            />
          </div>
          
          <div className="dialog-actions">
            <button 
              type="button" 
              className="cancel-button"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="save-button"
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Department'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDepartmentDialog;
